import { Component, Input, OnInit } from '@angular/core';
import { filter, map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
  AssignmentCustomerResponse,
  BaseCoreState,
  baseDocumentActions,
  baseDocumentSelectors,
  DocumentCategoryResponse,
  ProfileDocumentResponse,
  BaseOrderDirectionEnum,
} from 'base';
import { DocumentsHeaderSortKeys } from '../../_enums/base-customer-header-sort-keys.enum';

@Component({
  selector: 'base-customer-employee-documents-tab',
  templateUrl: './base-customer-employee-documents-tab.component.html',
})
export class BaseCustomerEmployeeDocumentsTabComponent implements OnInit {
  @Input() assignment: AssignmentCustomerResponse;
  documentList: Array<ProfileDocumentResponse & { categoryLabel: string }> = [];
  documentsOrderDirection: BaseOrderDirectionEnum;
  documentsOrderKey: number;

  documentsHeaderSortKeys = DocumentsHeaderSortKeys;
  directions = BaseOrderDirectionEnum;

  constructor(private store: Store<BaseCoreState>) {}

  ngOnInit() {
    this.setDocumentList();
  }

  onDocumentsOrderChanged(key: number): void {
    if (this.documentList.length) {
      this.documentsOrderKey = key;
      this.documentsOrderDirection =
        !this.documentsOrderDirection || this.documentsOrderDirection === this.directions.desc
          ? this.directions.asc
          : this.directions.desc;
      this.orderDocuments();
    }
  }

  private setDocumentList(): void {
    this.store.dispatch(baseDocumentActions.getDocumentCategories());
    this.store
      .select(baseDocumentSelectors.getDocumentCategories)
      .pipe(
        filter((documentCategoriesState) => !!documentCategoriesState.ok),
        take(1),
        map((documentCategoriesState: any) => documentCategoriesState.data)
      )
      .subscribe((documentCategories) => {
        if (documentCategories && this.assignment.documents) {
          documentCategories = Object.entries(documentCategories as DocumentCategoryResponse).reduce(
            (collector, item) => {
              collector.push({ label: item[1] as string, value: +item[0] });

              return collector;
            },
            [] as { label: string; value: number }[]
          );
          this.documentList = this.assignment.documents.map((document: ProfileDocumentResponse) => {
            return {
              ...document,
              categoryLabel: documentCategories.find(
                (category: { label: string; value: number }) => category.value === document.category
              )?.label,
            };
          });
        }
      });
  }

  private orderDocuments(): void {
    switch (this.documentsOrderKey) {
      case DocumentsHeaderSortKeys.name:
        this.documentList = [...this.documentList].sort((documentA, documentB) => {
          if (documentA.name === undefined && documentB.name === undefined) return 0;
          if (documentA.name === undefined) return -1;
          if (documentB.name === undefined) return 1;

          if (this.documentsOrderDirection === this.directions.asc) {
            return documentA.name.localeCompare(documentB.name);
          } else {
            return documentB.name.localeCompare(documentA.name);
          }
        });
        break;
      case DocumentsHeaderSortKeys.category:
        this.documentList = [...this.documentList].sort((documentA, documentB) => {
          if (this.documentsOrderDirection === this.directions.asc) {
            return documentA.categoryLabel.localeCompare(documentB.categoryLabel);
          } else {
            return documentB.categoryLabel.localeCompare(documentA.categoryLabel);
          }
        });
        break;
      case DocumentsHeaderSortKeys.validUntil:
        this.documentList = [...this.documentList].sort((documentA, documentB) => {
          if (this.documentsOrderDirection === this.directions.asc) {
            return new Date(documentA.validUntil!).getTime() - new Date(documentB.validUntil!).getTime();
          } else {
            return new Date(documentB.validUntil!).getTime() - new Date(documentA.validUntil!).getTime();
          }
        });
        break;
    }
  }
}
